<!-- Login User -->
<div class="cart-btn-toggle" onclick="cartopen()" *ngIf="isUserLoggedIn">
    <span class="cart-btn" style="box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    border-radius: 4px;
    color: #fff;
    border: 1px solid #008959;
    background-color: #008959;
    text-align: center;
    text-decoration: none;
    font-size: 16px;
    cursor: pointer;
    outline: none;
    font-family: Noto Sans, sans-serif;
    padding: 6px; " (click)="addtocart()" *ngIf="!productDetails?.isInCart">
      <i class="fas fa-shopping-cart"></i>
      {{'CART.CART_LBL' | translate}}</span>

    <!-- Product Increment & decrement -->
    <div class="price-btn11" *ngIf="productDetails?.isInCart">
      <div class="price-increase-decrese-group">
        <span class="decrease-btn">
          <button type="button" class="btn quantity-left-minus" data-type="minus" data-field="" (click)="decrement()">-
          </button>
        </span>
        <input type="text" name="quantity" class="form-controls input-number" disabled
          value="{{productDetails?.quantity >0 ? productDetails?.quantity :1}}">
        <span class="increase">
          <button type="button" class="btn quantity-right-plus" data-type="plus" data-field="" (click)="increment()">+
          </button>
        </span>
      </div>
    </div>
  </div>

<!-- Without Login User -->
  <div class="cart-btn-toggle" *ngIf="!isUserLoggedIn" routerLink="/login">
    <span class="cart-btn" style=" box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    border-radius: 4px;
    color: #fff;
    border: 1px solid #008959;
    background-color: #008959;
    text-align: center;
    text-decoration: none;
    font-size: 16px;
    cursor: pointer;
    outline: none;
    font-family: Noto Sans, sans-serif;
    padding: 6px;" (click)="addtocart()" *ngIf="!productDetails?.isInCart">
      <i class="fas fa-shopping-cart"></i>
      {{'CART.CART_LBL' | translate}}</span>
  </div>